define.alias("shared/components/shared/media-items/modal-display", "calendar/components/shared/media-items/modal-display");